import { app } from '../../../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.directory-groups.directory.import-users.upload-result', {
        url: '/upload-result',
        params: {importResult: null},
        views: {
            '@company.user-directories': 'companyUserDirectoriesDirectoryGroupsDirectoryImportUsersUploadResult'
        },
        resolve: {
            importResult,
        },
    });
}

/** @ngInject */
function importResult($stateParams) {
    return $stateParams.importResult;
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/directory-groups/directory/import-users/upload-result/upload-result.state.js